var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1520 445L1520 473",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1520.5,
    cy: 440.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1520 449L1513 445.2V439.2L1509 437L1520 431L1531 437V445H1529V438.1L1527 439.2V445.2L1520 449ZM1520 440.7L1526.85 437L1520 433.3L1513.15 437L1520 440.7ZM1520 446.725L1525 444.025V440.25L1520 443L1515 440.25V444.025L1520 446.725Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool3);
export default __webpack_public_path__ + "static/media/school_3.920971653b0cfa40fb585c6657dc3fe4.svg";
export { ForwardRef as ReactComponent };